export default {
    title: 'Calendario Semanal',
    subtitle: 'Ver llegadas de contenedores programadas por semana',
    currentWeek: 'Semana Actual',
    week: 'Semana',
    weekNumber: 'Semana {{number}}',
    noContainers: 'No hay contenedores programados para esta semana',
    containers: 'Contenedores',
    origins: 'Orígenes',
    senders: 'Remitentes',
    totalValue: 'Valor Total',
    commodities: 'Mercancías',
    expandDetails: 'Ver Detalles',
    collapseDetails: 'Ocultar Detalles',
    containerCount: '{{count}} contenedor',
    containerCount_plural: '{{count}} contenedores',
    originCount: '{{count}} origen',
    originCount_plural: '{{count}} orígenes',
    senderCount: '{{count}} remitente',
    senderCount_plural: '{{count}} remitentes',
    weekRange: '{{startDate}} - {{endDate}}',
    loading: 'Cargando calendario...',
    error: 'Error al cargar datos del calendario',
    retry: 'Reintentar',
    // Objetivos y metas
    targetReached: 'Objetivo Alcanzado',
    targetPending: 'Objetivo Pendiente',
    containerTarget: 'Objetivo de Contenedores',
    revenueTarget: 'Objetivo de Ingresos',
    editTarget: 'Editar Objetivo',
    confirmed: 'confirmados',
    pending: 'pendientes',
    // Tarjetas de Tendencia
    trendCards: {
        yearlyContainers: 'Contenedores Anuales',
        yearlyRevenue: 'Ingresos Anuales',
        monthlyContainers: 'Contenedores Mensuales',
        monthlyRevenue: 'Ingresos Mensuales',
    },
    // Gráfico
    chart: {
        titleContainers: 'Distribución de Contenedores por Semana',
        titleRevenue: 'Distribución de Ingresos por Semana',
        yAxisContainers: 'Número de Contenedores',
        yAxisRevenue: 'Ingresos (USD)',
        target: 'Objetivo',
        confirmed: 'Confirmados',
        pending: 'Pendientes',
        total: 'Total',
    },
    // Alternar vista
    viewContainers: 'Ver Contenedores',
    viewRevenue: 'Ver Ingresos',
    // Modal de Objetivo
    targetModal: {
        title: 'Editar Objetivo Semana {{week}}',
        containerTarget: 'Objetivo de Contenedores',
        revenueTarget: 'Objetivo de Ingresos (USD)',
        useDefault: 'Usar objetivo semanal predeterminado',
        resetToDefault: 'Restablecer al Objetivo Predeterminado',
    },
    // Pie de página
    viewingWeeks: 'Viendo {{count}} semanas para el año {{year}}',
    noContainersForYear: 'No hay contenedores para {{year}}',
    noContainersMessage: 'No hay contenedores programados para este año.',
    // Modo de Vista
    viewMode: {
        carousel: 'Carrusel',
        list: 'Lista',
    },
    // Carrusel
    carousel: {
        previous: 'Anterior',
        next: 'Siguiente',
        weekOf: 'Semana {{current}} de {{total}}',
        jumpToCurrent: 'Saltar a la Actual',
        noWeekData: 'No hay datos disponibles',
    },
    // Vista de Lista
    listView: {
        week: 'Semana',
        containerTarget: 'Objetivo de Contenedores',
        revenueTarget: 'Objetivo de Ingresos',
        containers: 'Contenedores',
        value: 'Valor',
        actions: 'Acciones',
        expand: 'Expandir',
        collapse: 'Contraer',
        containersDetails: 'Detalles de Contenedores ({{count}})',
        containerNumber: 'Número de Contenedor',
        route: 'Ruta',
        eta: 'ETA',
        status: 'Estado',
        confirmation: 'Confirmación',
    },
};

